import ScrollHint from 'scroll-hint';

$('a[href^="#"]').on('click', function () {
  const speed = 500;
  const easing = 'swing';
  const href = $(this).attr('href');
  const target = $(href == '#' || href == '' ? 'html' : href);
  const spt = parseInt($('html').css('scrollPaddingTop')) || 0;
  const smt = parseInt($(target).css('scrollMarginTop')) || 0;
  // スクロール先
  const position = target.offset().top - (spt + smt);
  $('html, body').animate({ scrollTop: position }, speed, easing);
  return false;
});

// 外部リンクのアニメーション
var urlHash = location.hash;
var headerHeight = $('.header').outerHeight(true);
if (urlHash) {
  $('body,html').stop().scrollTop(0);
  setTimeout(function() {
    var target = $(urlHash);
    var position = target.offset().top - headerHeight;
    $('body,html').stop().animate({
      scrollTop: position
    }, 500);
  }, 100);
}

// SP nav
$(document).ready(function () {
  $('.js-nav-bt').on('click', function () {
    if ($('.js-nav-content').hasClass('is-navOn')) {
      $(".js-nav-content").removeClass('is-navOn');
      $(".js-nav-logo").removeClass('is-navOn');
      $(this).removeClass('is-navOn');
    } else {
      $(".js-nav-content").addClass('is-navOn');
      $(".js-nav-logo").addClass('is-navOn');
      $(this).addClass('is-navOn');
    }
  });
  $('.js-nav-bt.is-navOn, .js-nav-logo.is-navOn, .js-nav-link').on('click', function () {
    $(".js-nav-content.is-navOn, .js-nav-logo.is-navOn, .js-nav-bt.is-navOn").removeClass('is-navOn');
  });
});

// ヘッダー: topMv または lowerMv を過ぎたら背景を付与（PC/SP 共通）
$(function () {
  const $header = $(".header");
  const $topMv = $(".topMv");
  const $lowerMv = $(".lowerMv");
  const $mv = $topMv.length ? $topMv : $lowerMv;
  if (!$header.length || !$mv.length) return;
  $(window).on("scroll", function () {
    const mvBottom = $mv.offset().top + $mv.outerHeight();
    if (mvBottom - 30 < $(this).scrollTop()) {
      $header.addClass("is-headerOn");
    } else {
      $header.removeClass("is-headerOn");
    }
  });
  // 初期表示時も判定
  $(window).trigger("scroll");
});

if (window.matchMedia("(max-width: 768px)").matches) {
  $(function () {
    $(window).on("scroll", function () {
      scrollHeight = $(document).height();
      scrollPosition = $(window).height() + $(window).scrollTop();
      footHeight = $(".js-footer-sp").innerHeight();
      if (scrollHeight - scrollPosition <= footHeight) {
        $(".js-cv-sp").addClass("is-none");
      } else {
        $(".js-cv-sp").removeClass("is-none");
      }
    });
  });

  jQuery(function($) {
    $('.js-sp-navDown').on('click', function () {
      $(this).next().slideToggle();
      $(this).toggleClass('is-on');
    });
  });
}

jQuery(function($) {
  //tab
  $(function () {
    $('.js-tab .js-tabItem').click(function () {
      var index = $('.js-tab .js-tabItem').index(this);
      $('.js-tab .js-tabItem').removeClass('is-on');
      $(this).addClass('is-on');
      $('.js-tabArea .js-tabcCntents').removeClass('is-on').eq(index).addClass('is-on');
    });
  });
});

// オープニング動画（#opening と #openingVideo が存在するページのみ実行）
document.addEventListener('DOMContentLoaded', () => {
  // .local内のtableを横スクロール用ラッパーで囲む（.card__priceTableは除外）
  const wrapLocalTables = () => {
    document.querySelectorAll('.local table').forEach((table) => {
      if (table.closest('.card__priceTable')) return;
      if (table.parentElement && table.parentElement.classList.contains('table-scroll-wrap')) return;
      const wrap = document.createElement('div');
      wrap.className = 'table-scroll-wrap';
      table.parentNode.insertBefore(wrap, table);
      wrap.appendChild(table);
    });
  };

  // スクロールヒントを未適用の .table-scroll-wrap にだけ初期化
  const initScrollHint = () => {
    const selector = '.table-scroll-wrap:not(.scroll-hint)';
    if (!document.querySelector(selector)) return;
    new ScrollHint(selector, {
      i18n: { scrollable: 'スクロールできます' }
    });
  };

  wrapLocalTables();
  initScrollHint();
  // プレビューや動的読み込みでDOMが遅れて入る場合に備え、load後と少し遅延でも実行
  window.addEventListener('load', () => {
    wrapLocalTables();
    initScrollHint();
  });
  setTimeout(() => {
    wrapLocalTables();
    initScrollHint();
  }, 500);
  // .local に後から追加された table にも対応（プレビューiframe等）
  const localEl = document.querySelector('.local');
  if (localEl && typeof MutationObserver !== 'undefined') {
    const observer = new MutationObserver(() => {
      wrapLocalTables();
      initScrollHint();
    });
    observer.observe(localEl, { childList: true, subtree: true });
  }

  const opening = document.getElementById('opening');
  const video = document.getElementById('openingVideo');
  const skip = document.getElementById('openingSkip');
  const site = document.getElementById('site') || document.body;

  if (!opening || !video) return;

  const LIMIT_HOURS = 6;
  const LIMIT_TIME = LIMIT_HOURS * 60 * 60 * 1000;
  const lastPlayed = localStorage.getItem('openingPlayedAt');
  const now = Date.now();

  if (lastPlayed && now - lastPlayed < LIMIT_TIME) {
    opening.remove();
    if (site) site.classList.add('is-show');
    return;
  }

  let ended = false;
  const endOpening = () => {
    if (ended) return;
    ended = true;
    if (opening) opening.classList.add('is-hide');
    if (site) site.classList.add('is-show');
    localStorage.setItem('openingPlayedAt', Date.now());

    setTimeout(() => {
      if (opening && opening.parentNode) opening.remove();
    }, 1300);
  };

  video.addEventListener('ended', endOpening);
  if (skip) skip.addEventListener('click', endOpening);

  setTimeout(endOpening, 8000);
});
